import { Theme } from '@mui/material';

export default {
    root: {
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        margin: 0,

        '.MuiFormControlLabel-label': {
            marginBottom: '0.35em',
        },

        '.custom-select__control': {
            maxWidth: '80px',
        },
    },
    select: {
        minWidth: 80,
        marginRight: 1,
    },
    extraText: {
        display: 'flex',
        marginLeft: 1.5,
        alignItems: 'center',

        '> div': {
            display: 'flex',
            alignItems: 'center',
        },

        '> div > p': {
            margin: 0,
        },
    },
    fields: {
        display: 'flex',
        alignItems: 'center',
    },
};
